export class TrackingUtils {
  static EventCategory = process.env.GA_EVENT_CATEGORY || "GA_EVENT_CATEGORY";
  static SendGA(eventName: string, category: string, label: string, action: string) {
    window.gtag("event", eventName, {
      content_type: `${category}__${label}__${action}`,
    });
    console.log("Google Analytics 4: ", `select_content. `, `Content Type: ${category}__${label}__${action}`);
  }
}
